import axios from "axios";
export default {
  name: "Web2Print",
  data: () => ({
    loading: false
  }),
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    hasUrl() {
      return !!this.currentUser?.web2print_url;
    }
  },
  methods: {
    async loadPage() {
      if (!this.hasUrl) return;
      //parse url to get the domain
      let url = new URL(this.currentUser.web2print_url);
      let domain = url.hostname;
      this.loading = true;
      //axios post request to get the page content
      let data;
      try {
        let res = await axios.post(
          "https://" + domain + "/pdf/gui/",
          {
            letmein: "letmein"
          },
          {
            responseType: "document"
          }
        );
        data = res.data;
      } catch (e) {
        console.error(e);
        this.loading = false;
        return;
      }
      //insert content of page / modify content so relative paths work
      window.document.getElementById("lkPage").innerHTML = data.body.innerHTML;
      let lkHead = document.createElement("div");
      data.head.querySelectorAll("script").forEach(script => {
        const jsScript = document.createElement("script");
        jsScript.src = script.src;
        jsScript.async = false;
        lkHead.appendChild(jsScript);
      });
      data.head.querySelectorAll("link").forEach(link => {
        const cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.href = link.href;
        lkHead.appendChild(cssLink);
      });
      document.querySelector("#lkHead").appendChild(lkHead);
      //set absolute path for form action
      document.querySelector("#siteForm").action = data.querySelector(
        "#siteForm"
      ).action;
      this.loading = false;
    }
  },
  mounted() {
    this.loadPage();
  }
};
